angular.module('impactx.compilationarticle').controller('CompilationArticleCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ProductSelectionService',
    'ToastService',
    'TranslationService',
    'BackService',
    'ConfirmationService',
    'CheckoutCatalogActions',
    'ToolbarService',
    CompilationArticleController
]);

function CompilationArticleController($scope, dataGen, $routeParams, ProductSelectionService, ToastService, TranslationService, BackService, ConfirmationService, CheckoutCatalogActions, ToolbarService) {
    var self = this;
    self.catId = $routeParams.catId;
    self.proId = $routeParams.proId ? parseInt($routeParams.proId) : 0;
    self.sortOrder = 'id';
    self.reversedSortOrder = false;
    self.allSelected = false;

    (self.getDialogData = function () {
        dataGen.getData(self, {
            proId: self.proId,
            catId: self.catId
        }, '/compilationarticle/dialog').then(function () {
            defineButtons();
        });
    })();

    self.saveDialog = function () {
        return dataGen.postAsForm(self, {formData: self.data}, '/compilationarticle/dialog/save').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.deleteCompilationArticle = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        ConfirmationService.showConfirmationDialog(function () {
            CheckoutCatalogActions.denyAll(event, [self.proId]).then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                BackService.back();
            })
        }, event, self.trns.deleteCompilationArticleTitle, TranslationService.get('accept'), TranslationService.get('abort'), self.trns.deleteCompilationArticleQuestion);
    };

    self.setSortOrder = function (columnName) {
        if (self.sortOrder == columnName && !self.reversedSortOrder) {
            self.reversedSortOrder = !self.reversedSortOrder;
        }
        else if (self.sortOrder == columnName && self.reversedSortOrder) {
            self.sortOrder = 'id';
            self.reversedSortOrder = false;
        }
        else {
            self.sortOrder = columnName;
            self.reversedSortOrder = false;
        }
    };

    self.addProducts = function (event) {
        var config = {
            title: self.trns.addNewProducts,
            locals: {
                usevcatfilter: true,
                vcat: self.data.vcat,
                useMultiSelect: true,
                vcatFilterEntryPoint: '/compilationarticle/catalog/input'
            },
            targetEvent: event
        };
        ProductSelectionService.open(config).then(function (productData) {
            if (productData) {
                var result = {};
                var formData = {
                    proIds: productData.map(function (product) {
                        return product.id
                    })
                };
                dataGen.postAsForm(result, formData, '/compilationarticle/dialog/products').then(function () {
                    if (impactX.isDefined(result, "data.entries")) {
                        self.data.products = self.data.products.concat(result.data.entries);
                    }
                });
            }
        });
    };

    self.removeProducts = function () {
        var index = self.data.products.length;
        while (index--) {
            if (self.data.products[index].isSelected) {
                self.data.products.splice(index, 1);
            }
        }
        if (self.data.products.length <= 0) {
            self.allSelected = false;
        }
    };

    self.setSelectedProduct = function (products) {
        angular.forEach(products, function (product) {
            product.isSelected = !self.allSelected;
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: self.trns.save,
                action: self.saveDialog,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: self.trns.delete,
                action: self.deleteCompilationArticle,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: self.trns.removeProducts,
                action: self.removeProducts,
                type: 'dialogaction',
                condition: canRemoveProducts
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return self.proId > 0;
    }

    function canRemoveProducts() {
        var selectedProducts = [];
        angular.forEach(self.data.products, function (product) {
            if (product.isSelected) {
                selectedProducts.push(product);
            }
        });
        return selectedProducts.length > 0
    }
}